import { render, staticRenderFns } from "./ipWhite.vue?vue&type=template&id=6d21468c&scoped=true"
import script from "./ipWhite.vue?vue&type=script&lang=js"
export * from "./ipWhite.vue?vue&type=script&lang=js"
import style0 from "./ipWhite.vue?vue&type=style&index=0&id=6d21468c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21468c",
  null
  
)

export default component.exports